import { Box, useTheme } from "@mui/material";
import React from "react";

const ExpensesPayments = ({ row }) => {
  const theme = useTheme();
  return (
    <>
      {row?.expensePaymentsList?.length > 0 ? (
        <Box>
          {row?.expensePaymentsList?.map((expensepaymentItem, index) => (
            <Box key={index} sx={{ display: "flex" }}>
              <h5>
                {expensepaymentItem?.expenseTitle}{" "}
                <span style={{ color: theme.color.PaperlabelColor }}>
                  {expensepaymentItem?.amount}
                </span>
              </h5>
            </Box>
          ))}
        </Box>
      ) : (
        "-"
      )}
    </>
  );
};

export default ExpensesPayments;
